var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTwitter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.619 0.911757C15.9558 1.37065 15.2214 1.72164 14.4442 1.95119C13.5897 0.987532 12.2127 0.649599 10.9962 1.10501C9.77977 1.56041 8.98254 2.71228 9 3.98929V4.66865C6.52773 4.73153 4.18755 3.57621 2.76623 1.59112C2.76623 1.59112 -0.00433025 7.70542 6.22944 10.4229C4.80296 11.3726 3.10366 11.8488 1.38095 11.7816C7.61472 15.1785 15.2338 11.7816 15.2338 3.96891C15.2331 3.77967 15.2146 3.5909 15.1784 3.40503C15.8853 2.72125 16.3841 1.85792 16.619 0.911757Z",
    stroke: "#7D86A1",
    strokeWidth: 1.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwitter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/twitter.adecc6d1.svg";
export { ForwardRef as ReactComponent };